module.exports = __webpack_public_path__ + "img/13.ca0314f4.jpg";